import _ from '@/utils/lodash-optimized'
import { Component } from 'react'
import { connect } from 'react-redux'
import statuses from 'shared_src/dictionaries/episodeOfCare/statuses'

import { fhirDate, STANDARD_DATE } from '../../../lib/Date/Format'
import './styles.scss'
import * as Compartment from '../../../selectors/compartment'
import * as Patient from '../../../selectors/patient'
import {
  bindTargetMixin,
  DateInput,
  SaveButton,
  SelectInput,
  TextAreaInput,
  today
} from '../../shared/FormBuilder'

class CaseManagementForm extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)
    const {
      episodeOfCare,
      par,
      dischargeDate,
      dischargeReason,
      dateOfDeath,
      partnerOrganization,
      userPartnerOrganization
    } = props
    const currentStatus = episodeOfCare.status

    const value = {
      status: currentStatus,
      notes: '',
      par: par ? parseInt(par, 10) : undefined,
      reason: dischargeReason || undefined,
      dateOfDeath: dateOfDeath || undefined,
      dischargeDate: dischargeDate || undefined,
      partnerOrganization: partnerOrganization || userPartnerOrganization
    }

    this.state = {
      value,
      initValue: value
    }
  }

  componentDidMount () {
    this.validateForm()
  }

  componentDidUpdate () {
    this.validateForm()
  }

  getValue = () => ({ ...this.state.value })

  handleSubmit = () => {
    const { onSubmit } = this.props
    const value = this.getValue();
    [ 'dischargeDate', 'dateOfDeath' ].forEach(key => {
        const item = value?.[key]
      if (!_.isNil(item)) {
        let newDate = fhirDate(item, STANDARD_DATE)
        if (newDate === 'Invalid date') {
          newDate = item
        }
        _.set(value, key, newDate)
      }
    })

    this.setState({ isSubmitting: true })
    if (onSubmit) {
      onSubmit(value)
    }
  }

  validateForm = () => {
    const { value } = this.state

    if (value) {
      let formInvalid = false
      if (value.status === 'finished') {
        if (_.isNil(value.reason) || _.isNil(value.dischargeDate)) {
          formInvalid = true
        }
        if (value.reason === 'expired' && _.isNil(value.dateOfDeath)) {
          formInvalid = true
        }
      }
      if (formInvalid !== this.state.formInvalid) {
        this.setState({ formInvalid })
      }
    }
  }

  render () {
    const { isSubmitting, formInvalid, value, initValue } = this.state

    const reasons = [
      {
        value: 'no-longer-eligible',
        label: 'No longer eligible'
      },
      {
        value: 'patient-declined',
        label: 'Patient declined'
      },
      {
        value: 'expired',
        label: 'Expired'
      }
    ]

    const disableSave = initValue.status === value.status || !value.status

    const saveBtn = (
      <div
        className='col-xs-3'
        style={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <SaveButton
          formKey={this.props.formKey}
          onClick={this.handleSubmit}
          disabled={isSubmitting || formInvalid || disableSave}
        />
      </div>
    )
    const dischargedControls = (
      <div>
        <div className='row'>
          <div className='col-xs-6'>
            <h2>Discharge Information</h2>
          </div>
          <div className='col-xs-6'>
            <h2>If Expired</h2>
          </div>
        </div>
        <div className='row'>
          <div className='col-xs-3'>
            <DateInput
              label='Discharge Date'
              name='dischargeDate'
              maxDate={today}
              required
            />
          </div>
          <div className='col-xs-3'>
            <SelectInput
              label='Reason'
              name='reason'
              options={reasons}
              required
            />
          </div>
          <div className='col-xs-3'>
            <DateInput
              label='Date of Death'
              name='dateOfDeath'
              maxDate={today}
              disabled={this.state.value.reason !== 'expired'}
              required={this.state.value.reason === 'expired'}
            />
          </div>
          {saveBtn}
        </div>
      </div>
    )

    let rc = 'nh-status-select'
    const { status } = this.state.value
    if (status !== 'finished') {
      rc += ' col-xs-3'
    } else {
      rc += ' col-xs-6'
    }

    return (
      <div className='nh-case-management'>
        <div className='row'>
          <div className={rc}>
            <SelectInput
              name='status'
              options={(statuses || []).filter(s => s.value !== 'all')}
              label='Status'
              required
              noSort
            />
          </div>

          <div className='col-xs-6'>
            <TextAreaInput
              style={{ height: '40px' }}
              name='notes'
              label='Notes'
            />
          </div>
          {status !== 'finished' && saveBtn}
        </div>
        {status === 'finished' && dischargedControls}
      </div>
    )
  }
}

const mapStateToProps = redux => ({
  episodeOfCare: Compartment.episodeOfCare(redux),
  dischargeDate: Patient.getDischargeDate(redux),
  dateOfDeath: Patient.getDateOfDeath(redux),
  dischargeReason: Patient.getDischargeReason(redux)
})

export default connect(mapStateToProps)(CaseManagementForm)
